module.exports = __webpack_public_path__ + "img/sidenav-item-goals.b7e849cc.svg";